var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cardContentT" }, [
    _c(
      "div",
      {
        staticClass: "flex",
        staticStyle: {
          "margin-top": "5px",
          "padding-left": "10px",
          "box-sizing": "border-border-box",
        },
      },
      _vm._l(_vm.navList, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "choseType",
            class: _vm.active === index ? "select" : "",
            on: {
              click: function ($event) {
                return _vm.typeSelect(item, index)
              },
            },
          },
          [_vm._v(" " + _vm._s(item.name) + " ")]
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "chart" },
      [_c("loadEchart", { ref: "echarts" })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }